import { useState, useEffect } from "react";

import {
  Card,
  CardContent,
  Box,
  Grid,
  TextField,
  IconButton,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";

import Editor from "components/EmailEditor";

// utils
import axios from "utils/axios";
import useLocales from "locales/useLocales";
// import StrutturaContext from "contexts/StrutturaContext";
import { translateLocaleObj, normalizeData, defaultValue } from "utils/utils";
import { toast } from "react-toastify";

const Templates = function () {
  const { translate, currentLang } = useLocales();
  // const { strutturaId } = StrutturaContext.useStruttura();

  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [translatedTemplate, setTranslatedTemplate] = useState(null);
  const [edited, setEdited] = useState({});

  const mTypes = [
    "richiesta_struttura_gestore",
    "richiesta_struttura_cliente",
    "prenotazione_camera_gestore",
    "prenotazione_camera_cliente",
    "aggiunto_utente_a_listino",
  ];

  const reloadTemplate = async () => {
    setEdited({});
    setSelectedTemplate(null);
    let { data: templates } = await axios.get(
      `/api/booking-email-templates?message_type=${selectedTemplate.message_type}&language=${currentLang.value}`
    );
    let norm = normalizeData(templates);
    console.log(norm);
    setSelectedTemplate(norm);
    setTranslatedTemplate(translateLocaleObj(norm, currentLang.value));
  };

  useEffect(() => {
    if (selectedTemplate) {
      reloadTemplate();
    }
  }, [currentLang]);

  return mTypes ? (
    <Grid container spacing={2}>
      <Grid item xs={12} container spacing={2} justifyContent="space-evenly">
        {mTypes.map((item) => (
          <LoadingButton
            key={item.id}
            color="primary"
            variant={
              translatedTemplate != null &&
              selectedTemplate.message_type != null &&
              selectedTemplate.message_type == item
                ? "contained"
                : ""
            }
            onClick={async () => {
              setEdited({});
              setSelectedTemplate(null);
              let { data: templates } = await axios.get(
                `/api/booking-email-templates?message_type=${item}&language=${currentLang.value}`
              );
              let norm = normalizeData(templates);
              setSelectedTemplate(norm);
              setTranslatedTemplate(
                translateLocaleObj(norm, currentLang.value)
              );
            }}
          >
            {translate(item)}
          </LoadingButton>
        ))}
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Box
              sx={{
                overflow: {
                  xs: "auto",
                  sm: "unset",
                },
              }}
            >
              {selectedTemplate ? (
                <Grid container spacing={3}>
                  <Grid container alignItems="center" item xs={12}>
                    <Grid item xs={11}>
                      <TextField
                        fullWidth
                        label="Subject"
                        value={
                          edited.subject
                            ? edited.subject
                            : translatedTemplate?.subject
                        }
                        onChange={(e) => {
                          setEdited({
                            ...edited,
                            subject: e.target.value,
                          });
                        }}
                      />
                    </Grid>
                    <Grid item xs={1} container justifyContent="center">
                      <IconButton
                        onClick={async () => {
                          try {
                            await axios.put(
                              `/api/booking-email-templates/${selectedTemplate.id}`,
                              {
                                data: {
                                  subject: defaultValue(
                                    "subject",
                                    edited,
                                    translatedTemplate
                                  ),
                                  json: edited.json,
                                  html: edited.html,
                                },
                              }
                            );
                            toast.success(translate("template_saved"));
                          } catch (error) {
                            toast.error(translate("error_saving_template"));
                          }
                        }}
                      >
                        <SaveIcon color="primary" />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Editor
                      template={translatedTemplate}
                      onChange={(json, html) => {
                        setEdited({
                          ...edited,
                          html: html,
                          json: json,
                        });
                      }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <h1 style={{ textAlign: "center" }}>
                  {translate("select_template")}
                </h1>
              )}
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  ) : (
    <div>
      <h2>Loading</h2>
    </div>
  );
};

export default Templates;
